var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 3.05469C8.02794 3.05469 5 6.08881 5 9.81706C5 15.401 11.3006 20.7628 11.5689 20.9883C11.619 21.031 11.6826 21.0547 11.7485 21.0551C11.8143 21.0555 11.8782 21.0327 11.9289 20.9906C12.1972 20.7689 18.5 15.4994 18.5 9.81706C18.5 6.08881 15.4721 3.05469 11.75 3.05469ZM11.7511 20.4011C10.7156 19.4757 5.5625 14.6304 5.5625 9.81706C5.5625 6.39819 8.33844 3.61719 11.75 3.61719C15.1616 3.61719 17.9375 6.39819 17.9375 9.81706C17.9375 14.7119 12.7895 19.4881 11.7511 20.4011Z",
    fill: "#1B2646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6.42969C9.88869 6.42969 8.375 7.94337 8.375 9.80469C8.375 11.666 9.88869 13.1797 11.75 13.1797C13.6113 13.1797 15.125 11.666 15.125 9.80469C15.125 7.94337 13.6113 6.42969 11.75 6.42969ZM11.75 12.6172C10.1992 12.6172 8.9375 11.3555 8.9375 9.80469C8.9375 8.25388 10.1992 6.99219 11.75 6.99219C13.3008 6.99219 14.5625 8.25388 14.5625 9.80469C14.5625 11.3555 13.3008 12.6172 11.75 12.6172Z",
    fill: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.005fa2187c9ec779b0d59b442d5c9edd.svg";
export { ForwardRef as ReactComponent };